module.exports = __webpack_public_path__ + "static/media/scopusLogoOrange.fd52a7e3.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/scopusLogoOrange.svg
// module id = 1627
// module chunks = 1